import { FC } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import styled from 'styled-components';

import { useCurrentUserQuery } from '../../api';

const UserDisplayContainerStyled = styled.div`
	gap: 8px;
	display: flex;
	align-items: center;
	margin: 0 auto;
	padding: 18px 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: calc(100vw - 32px);
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
	}
`;

const UserProfileInfoContainerStyled = styled.div``;

const UserProfileNameStyled = styled.p`
	margin: 0;
	color: #262626;
	letter-spacing: -0.15px;
	font-weight: 600;
	font-style: normal;
	font-size: 14px;
	line-height: 22px;
`;

const UserProfileEmailStyled = styled.p`
	margin: 0;
	color: #8c8c8c;
	letter-spacing: -0.15px;
	font-weight: 400;
	font-style: normal;
	font-size: 14px;
	line-height: 22px;
`;

export const UserDisplayM: FC = () => {
	const { data: user } = useCurrentUserQuery();

	if (!user) {
		return null;
	}

	const userDisplayName = user.firstName || user.login;

	return (
		<UserDisplayContainerStyled>
			<Avatar src={user.avatarUrl} icon={<UserOutlined />} />
			<UserProfileInfoContainerStyled>
				<UserProfileNameStyled>{userDisplayName}</UserProfileNameStyled>
				<UserProfileEmailStyled>{user.login}</UserProfileEmailStyled>
			</UserProfileInfoContainerStyled>
		</UserDisplayContainerStyled>
	);
};
